/**
 * BIRHAUS v3.0 Border Radius System
 * Radical minimalist approach with perfect curves
 */

export const borderRadiusV3 = {
  none: '0px',
  xs: '8px',       // Subtle rounding
  sm: '12px',      // Noticeable curve
  md: '20px',      // Statement rounding
  lg: '28px',      // Bold curves
  xl: '40px',      // Super rounded
  '2xl': '56px',   // Ultra rounded
  '3xl': '72px',   // Maximum curve
  pill: '9999px',  // Perfect pill shape
  circle: '50%',   // Perfect circle
} as const

export const borderWidthV3 = {
  none: '0px',
  hairline: '0.5px',
  thin: '1px',
  base: '2px',
  thick: '3px',
  bold: '4px',
} as const

// Semantic border mappings for components
export const componentBorders = {
  button: borderRadiusV3.lg,      // 28px
  card: borderRadiusV3.xl,        // 40px
  input: borderRadiusV3.md,       // 20px
  modal: borderRadiusV3['2xl'],   // 56px
  badge: borderRadiusV3.sm,       // 12px
  avatar: borderRadiusV3.lg,      // 28px
  tooltip: borderRadiusV3.sm,     // 12px
  dropdown: borderRadiusV3.md,    // 20px
  nav: borderRadiusV3.lg,         // 28px
  tab: borderRadiusV3.pill,       // 9999px
} as const